'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsRoute = undefined;

var _settingsOnenter = require('features/Settings/settings.onenter.saga');

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var SettingsRoute = exports.SettingsRoute = function SettingsRoute(store, client) {
  return {
    path: '/settings',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_settingsOnenter.settingsOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('features/Settings/SettingsContainer').SettingsContainer);
      }, 'settings');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'add-ons',
          component: require('features/Settings/Membership/Bundles/BundlesContainer').BundlesContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(_settingsOnenter.addOnsOnEnterSaga, client, replaceState, nextState).done.then(cb, cb);
          }
        }, { path: 'contact', component: require('features/Settings/Contact/ContactSettingsContainer').ContactSettingsContainer }, { path: 'charges', component: require('features/Settings/RecentCharges/RecentChargesContainer').RecentChargesContainer }, { path: 'membership(/offer)', component: require('features/Settings/Membership/MembershipContainer').MembershipContainer }, {
          path: 'plans',
          component: require('features/Settings/Membership/Plans/PlansContainer').PlansContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(_settingsOnenter.plansOnEnterSaga, client, replaceState, nextState).done.then(cb, cb);
          }
        }, {
          path: 'billing(/update)',
          component: require('features/Settings/Billing/BillingContainer').BillingContainer
        }, {
          path: 'account/update',
          component: require('features/Settings/ChangePassword/ChangePassword').ChangePassword
        }, {
          path: 'account',
          component: require('features/Settings/Account/AccountSettingsContainer').AccountSettingsContainer
        }]);
      }, 'settings');
    }
  };
};